import store from '@/store';
import { ToastType, MutationTypes } from '@/store/toast';

export const showToast = (type: ToastType, title: string, message: string) => {
  store.commit(MutationTypes.ADD_TOAST, {
    type, title, message,
  });
};

export const removeToast = (id: string) => {
  store.commit(MutationTypes.REMOVE_TOAST, id);
};
